import type { Point } from "../state/types";

/** Ширина игрового мира (логич. пиксели) */
export const W = 1600;

/** Высота игрового мира (логич. пиксели) */
export const H = 900;

/** Лимит критических нарушений за смену */
export const MAX_VIOL = 3;

/** Y-координата главной рулежной дорожки */
export const TAXI_Y = 585;

/** Ключ localStorage: выбранный режим смены */
export const MODE_KEY = "asf_mode_v2";

/** Ключ localStorage: прогресс туториала */
export const TUT_KEY = "asf_tut_v1";

/** Ключ localStorage: метаданные endless-режима */
export const ENDLESS_META_KEY = "asf_endless_meta";

/** Здание терминала (прямоугольник) */
export const TERMINAL = { x: 400, y: 740, w: 760, h: 140 } as const;

/**
 * Точки перрона — ожидание свободного гейта.
 * Копии не нужны: координаты неизменяемы.
 */
export const APRON: readonly Point[] = [
  { x: 1300, y: 660 },
  { x: 1370, y: 730 },
  { x: 1300, y: 800 },
  { x: 1215, y: 800 },
  { x: 1240, y: 700 },
  { x: 1340, y: 780 },
];

/**
 * Точки hold-short у каждой ВПП (индекс = id полосы).
 */
export const HOLD_SHORT: readonly Point[] = [
  { x: 272, y: 330 },
  { x: 272, y: 530 },
];

/**
 * Ключ рекорда очков для режима.
 * @param mode — id режима (`quick` / `standard` / …)
 */
export function bestKey(mode: string): string {
  return "asf_best_" + mode;
}

/**
 * Прочитать лучший счет режима из localStorage.
 * @param mode — id режима
 */
export function bestScore(mode: string): number {
  let v = 0;
  try {
    v = parseInt(localStorage.getItem(bestKey(mode)) || "0", 10) || 0;
  } catch {
    /* игнор */
  }
  return v;
}

/**
 * Сохранить лучший счет режима.
 * @param v — очки
 * @param mode — id режима
 */
export function saveBest(v: number, mode: string): void {
  try {
    localStorage.setItem(bestKey(mode), String(v));
  } catch {
    /* игнор */
  }
}

/**
 * Прочитать метаданные endless-режима.
 */
export function endlessRec(): Record<string, unknown> {
  try {
    return JSON.parse(localStorage.getItem(ENDLESS_META_KEY) || "{}") as Record<
      string,
      unknown
    >;
  } catch {
    return {};
  }
}

/**
 * Сохранить метаданные endless-режима.
 * @param meta — произвольный объект метаданных
 */
export function saveEndlessMeta(meta: Record<string, unknown>): void {
  try {
    localStorage.setItem(ENDLESS_META_KEY, JSON.stringify(meta));
  } catch {
    /* игнор */
  }
}
